// Resolves a media URL, preferring the Cloudflare R2 public CDN when
// a storage_path is known, and falling back to a backend proxy URL
// (e.g. `${API}/photos/{photo_id}/stream`) when it isn't.
//
// One helper, one migration knob: when we switch to files.eventdrop.co
// it's a single env-var change.
//
// Two call shapes are supported:
//   1. Legacy / generic: getMediaUrl(storagePath, fallbackUrl)
//   2. Size-aware:       getMediaUrl(uploadDoc, { size: 'thumb_400' | 'thumb_800' })
//      where uploadDoc has `storage_path`, `thumbnail_400_path`,
//      `thumbnail_800_path`. Falls back to the original storage_path when
//      the requested thumb is missing (e.g. legacy uploads predating
//      thumbnail generation).
const R2_BASE = (process.env.REACT_APP_R2_BASE_URL || '').replace(/\/$/, '');

const buildUrl = (path) => {
  if (!path || !R2_BASE) return null;
  const key = String(path).replace(/^\//, '');
  return `${R2_BASE}/${key}`;
};

export const getMediaUrl = (pathOrPhoto, fallbackOrOptions, options) => {
  // Object form — size-aware
  if (pathOrPhoto && typeof pathOrPhoto === 'object') {
    const photo = pathOrPhoto;
    const opts = (options && typeof options === 'object')
      ? options
      : (fallbackOrOptions && typeof fallbackOrOptions === 'object'
          ? fallbackOrOptions
          : {});
    const size = opts.size;
    let path = photo.storage_path;
    if (size === 'thumb_400' && photo.thumbnail_400_path) {
      path = photo.thumbnail_400_path;
    } else if (size === 'thumb_800' && photo.thumbnail_800_path) {
      path = photo.thumbnail_800_path;
    }
    return buildUrl(path);
  }
  // String form — legacy
  return buildUrl(pathOrPhoto) || fallbackOrOptions || null;
};
